import iconBoards from "../assets/images/allproducts/exp1.svg";
import iconDrywall from "../assets/images/allproducts/exp2.svg";
import iconCeiling from "../assets/images/allproducts/exp3.svg";
import iconAccessories from "../assets/images/allproducts/exp4.svg";

/** Shared list for All Products explore grid and Boards “continue exploring” section */
export const productExploreCategories = [
  {
    title: "Boards",
    description: "High-quality boards for strong and reliable performance.",
    icon: iconBoards,
    to: "/products/boards",
  },
  {
    title: "Drywall metal frame",
    description: "Strong metal support for drywall systems.",
    icon: iconDrywall,
    to: "/products/drywall-metal-frame",
  },
  {
    title: "Ceiling metal frame",
    description: "Stable structure for secure ceilings.",
    icon: iconCeiling,
    to: "/products/ceiling-metal-frame",
  },
  {
    title: "Accessories",
    description: "Key parts for easy installation and clean finish.",
    icon: iconAccessories,
    to: "/accessories",
  },
];
